/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/semi */
/* eslint-disable eqeqeq */
/* eslint-disable no-trailing-spaces */
/* eslint-disable @typescript-eslint/type-annotation-spacing */
import { Component, OnInit } from '@angular/core';
import { AlertController, NavController } from '@ionic/angular';
import { GlobalVariable } from '../global';
import { UserApiService } from '../services/user-api.service';
@Component({
  selector: 'app-settings',
  templateUrl: './settings.page.html',
  styleUrls: ['./settings.page.scss'],
})
export class SettingsPage implements OnInit {
  enablekiosk = false;
  counter = 0;
  appNumber: string;
  constructor(
    private alertController: AlertController,
    public globals: GlobalVariable,
    public server: UserApiService
    
  ) {
  }

  ngOnInit() {
  }
  enableKioskMode() {
    this.counter++;
    console.log(this.counter)
    if (this.counter == 10) {
      this.enablekiosk = true;
      console.log('enabled')
      this.kioskAlert()
    }
  }


  async kioskAlert() {
    const alert = await this.alertController.create({
      cssClass: 'KioskAlert',
      header: 'Enter Secret Password',
      inputs: [

        {
          name: 'pass',
          type: 'password',
          placeholder: 'Your Password',
          cssClass: 'specialClass',
          attributes: {
            maxlength: 20,
          }
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            this.counter = 0;
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Submit',
          handler: (data) => {
            this.counter = 0;
            console.log(data);
            if (data.pass == '1111') {

              let kiosk = JSON.parse(localStorage.getItem('kiosk'))
              console.log('kioskfromlocal', kiosk)
              if (kiosk != null) {
                this.globals.kiosk_flag = kiosk;

                if (this.globals.kiosk_flag == true) {
                  console.log('true kiosk')
                  this.globals.presentToast('Kiosk mode disabled');
                  this.globals.kiosk_flag = false
                  localStorage.setItem('kiosk', JSON.stringify(false));
                } else {
                  console.log('false kiosk')
                  this.globals.presentToast('Kiosk mode activated');
                  this.globals.kiosk_flag = true;
                  localStorage.setItem('kiosk', JSON.stringify(true));
                }
              }
              else {
                console.log('first time,enable kiosk')
                this.globals.presentToast('Kiosk mode activated');
                this.globals.kiosk_flag = true;
                localStorage.setItem('kiosk', JSON.stringify(true));
              }
            }
          }
        }
      ]
    });

    await alert.present();
  }


}
